import { Head } from '@inertiajs/react';
import { MainLayout } from '../../layouts/MainLayout';
import { PlanComparison } from '../../components/precios-al-dia/PlanComparison';

interface Plan {
  id: number;
  name: string;
  slug: string;
  price: number;
  badge: string | null;
  description: string | null;
  features: string[];
}

interface PreciosAlDiaProps {
  plans: Plan[];
  featureCatalog: Record<string, string>;
}

export default function PreciosAlDia({ plans, featureCatalog }: PreciosAlDiaProps) {
  return (
    <MainLayout>
      <Head>
        <title>Precios al día | Abasto Virtual</title>
        <meta
          name="description"
          content="Recibí la lista de precios completa todos los días, enterate de los movimientos del mercado en tiempo real y no vendas barato."
        />
      </Head>

      {/* Hero */}
      <section className="relative overflow-hidden bg-gradient-to-br from-[#0b3d1a] via-[#12622b] to-[#1EAA25] px-6 py-20 text-center">
        <div className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-white/10 blur-3xl" />
        <div className="pointer-events-none absolute -bottom-24 -right-24 h-72 w-72 rounded-full bg-white/10 blur-3xl" />
        <div className="relative z-10 mx-auto max-w-2xl">
          <span className="mb-5 inline-flex items-center gap-2 rounded-full border border-white/25 bg-white/10 px-4 py-1.5 text-sm font-medium text-white/90 backdrop-blur">
            <span className="h-2 w-2 rounded-full bg-green-300" />
            Para verdulerías y revendedores
          </span>
          <h1 className="mb-4 text-4xl font-extrabold leading-tight text-white sm:text-5xl">
            Enterate primero. Vendé mejor.
          </h1>
          <p className="mx-auto max-w-xl text-lg leading-relaxed text-white/85">
            Sé el primero en saber cómo se mueve el mercado. Lista completa de precios todos los
            días y alertas al instante de cada movimiento, para que ningún cambio te agarre
            desprevenido.
          </p>
          <a
            href="#planes"
            className="mt-8 inline-block rounded-xl bg-white px-6 py-3 text-base font-semibold text-[#12622b] transition hover:bg-white/90"
          >
            Ver planes
          </a>
        </div>
      </section>

      {/* Plans */}
      <div id="planes">
        <PlanComparison plans={plans} featureCatalog={featureCatalog} />
      </div>
    </MainLayout>
  );
}
